import { datadogRum } from '@datadog/browser-rum';

import Experiments from '../definitions/ExperimentsObservable';
import Config from '../definitions/Config';
import { FetchError } from './fetchWithErrorHandling';



/**
 * Eeek! Something bad happened, the sky is falling. Tell everyone: console.error() and report to our observability framework.
 * @param {Error} error - some error object
 * @param {object} [moreInfo] - key/value object with additional context
 * @returns undefined
 * @example noticeError(new RangeError(`[someFunctionName] -- unexpected value for thingType: “${thingType}”`),
 *      {
 *          documentId: context.activeDocument.id,
 *          email: context.activeDocument.occupant?.email,
 *          exception: ex,
 *      });
 */

function noticeError(error, moreInfo) {
    // Augment with any relevant details before this happened
    const extendedInfo = {
        ...moreInfo,
        experiments: Experiments.toJSON(),
    };

    // eslint-disable-next-line no-console
    console.error(error, extendedInfo);   // the error object will be .toString()’d

    // Don't care about 500 errors, as they aren't caused by the client
    // 520 errors are from Cloudflare, these can be tracked outside of the FE
    // Other 5xx errors should be logged as some of them can be problems on our end, or have no logging elsewhere
    if (error instanceof FetchError && (error.status === 500 || error.status === 520)) {
        return;
    }

    if (Config.ENABLE_DATADOG) {
        datadogRum?.addError(error, extendedInfo);
    }
}

export default noticeError;
